import { Button } from '@thanx/uikit/button'
import { useStyletron } from '@thanx/uikit/theme'
import { buildTranslate } from 'locales'
import React from 'react'

type Props = {
  image: string
  alt?: string
  isLoading: boolean
  disabled?: boolean
}

const t = buildTranslate('cms.content.menu_category.sidebar')

const Sidebar = ({ isLoading, disabled, image, alt }: Props) => {
  const [css] = useStyletron()

  return (
    <>
      <Button
        className={`mb-xxxl px-s ${css({ width: '200px' })}`}
        isLoading={isLoading}
        disabled={disabled}
        type={'submit'}
      >
        {t('publish')}
      </Button>
      <img
        className={`mb-xl ${css({
          width: '200px',
        })}`}
        src={image}
        alt={alt ?? t('preview')}
      />
    </>
  )
}

export default Sidebar
